"use client";

import GridBarFiltersAtomClear from "@/components/Grid/Bar/Filters/Atom/Clear";
import { SupLoader, SupText } from "@repo/core-ui";
import React, { type PropsWithChildren, useMemo, useState } from "react";

import { useStoredData, countFilters } from "@/store/Context";
import { SupChevronDown, SupChevronUp } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";

interface GridBarFiltersAtomProps extends PropsWithChildren {
  name: string;
  title?: string;
  disabled?: boolean;
  isLoading?: boolean;
  caption?: string;
  hideCount?: boolean;
}

export default function GridBarFiltersAtom({ children, name, title, disabled = false, isLoading = false, caption, hideCount = false }: GridBarFiltersAtomProps) {
  const storedData = useStoredData();

  const [opened, toggleOpened] = useState(false);

  const displayTitle = title ?? name;

  const filtersCount = useMemo(() => {
    return countFilters(storedData.filters, name);
  }, [storedData.filters, name]);

  const openHandler = () => {
    disabled || toggleOpened(!opened);
  };

  return (
    <div className="py-2">
      <header className={twMerge("flex w-full items-center justify-start", disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer")} onClick={openHandler}>
        <h2 className="txt-header-dgt my-0 font-[400] leading-[40px]">{displayTitle}</h2>
        {!hideCount && <span className="sup-badge mx-2 w-5 font-bold">{filtersCount > 9 ? "9+" : filtersCount}</span>}
        {caption && (
          <SupText variant="caption" className="mx-2">
            {caption}
          </SupText>
        )}
        {filtersCount > 0 && <GridBarFiltersAtomClear dispatchAction={{ type: "clearFilter", filterName: name }} />}
        <span className="ml-auto">{isLoading ? <SupLoader isSmall /> : opened ? <SupChevronUp /> : <SupChevronDown />}</span>
      </header>
      {opened && <div>{children}</div>}
    </div>
  );
}
